import Entities from "../dynamics/entities.json";

const DEFAULT_ENTITY_ID = 1;
const getEntityById = (entityId) => Entities.find(({ id }) => id === entityId);
export { DEFAULT_ENTITY_ID, Entities, getEntityById };
